import React from 'react'
import getText from '../strings'
import Svg from './Svg'
import styled from 'react-emotion'
import cookie from 'js-cookie'
import TopMenu from './TopMenu'
import { colors, Container } from '../../styles'
import { useAuth } from '../../authContext'

const Wrapper = styled('div')`
  padding-top: 10px;
  background-color: ${colors.tui_blue_100};
  color: ${colors.tui_white};
  min-height: 110px;
  >div {
    display: flex;
    align-items: center;
    @media (max-width: 992px) { 
      margin: 0 10px;
    } 
  }
  @media (max-width: 992px) {
    padding: 10px 0;
    min-height: 0;    
  }  
`

const Name = styled('div')`
  h1 {
    text-transform: none;
    color: ${colors.tui_white};
    font-size: 2.5em;
    margin: 5px 0;
  }
  @media (max-width: 992px) {
    h1 {
      font-size: 1.5em;
    }   
  }
`

const Image = styled('div')`
  margin-right: 20px;
  img {
    max-height: 75px;
  }
  @media (max-width: 992px) {
    margin-right: 10px;
    img {
      max-height: 40px;
    }
  }
`

const User = styled('div')`
  width: 65px;
  height: 65px;
  border-radius: 50%;
  background-color: ${colors.tui_blue_25};
  font-size: 1.5em;
  margin-right: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  color: ${colors.tui_dark_blue};
  .pictogram {
    width: 35px;
    height: 35px;
  }
  @media (max-width: 992px) {
    height: 40px;
    width: 40px;
    font-size: 1em;
    margin-right: 10px;
    .pictogram {
      width: 20px;
      height: 20px;
    }
  }
`

const UserIcon = ({ firstName, lastName }) => (
  <User>
    {firstName
      ? firstName.charAt(0).toUpperCase() + lastName.charAt(0).toUpperCase()
      : <Svg icon="user" />
    }
  </User>
)

export default () => {
  const { profile } = useAuth()
  const impersonate = cookie.get('customer.mytui.web.impersonate.uid')
  const impersonatedUser = impersonate ? `(inloggad som ${impersonate})` : ''
  return (
    <div>
      <Wrapper>
        <Container>
          {profile.picture ?
            <Image>
              <img src={profile.picture} className="image-round" alt="" />
            </Image>
            : <UserIcon firstName={profile.firstName} lastName={profile.lastName} />
          }
          <Name>
            {profile.firstName || profile.lastName
              ? (<><h1>{profile.firstName} {profile.lastName}</h1>{impersonate && <p>{impersonatedUser}</p>}</>)
              : <h1>{getText('hero', 'myaccount')}</h1>
            }
          </Name>
        </Container>
      </Wrapper>
      <TopMenu />
    </div>
  )
}
